
$(function () {
  $('.product-description > p strong:contains("Create number"),p strong:contains("Block number")')
    .parent()
    .remove();

  $(".product-description > p").each(function () {
    let t = $(this).text();
    t = t.replace("< /p >", "");
    $(this).text(t);
  });

  $(".product-description").append(
    '<div class="inventory_rows stock_a"><strong>Number of slabs available : </strong> <div class="dot-pulse inventory_loading"></div></div>'
  );

  $(".product-description").append(
    '<div class="inventory_rows stock_b"><strong>Total square feet available : </strong> <div class="dot-pulse inventory_loading"></div></div>'
  );

  $(".product-description").append(
    '<br /><div class="inventory_rows stock_c"><strong>Average square feet per slab : </strong> <div class="dot-pulse inventory_loading"></div></div>'
  );

  if (current_sku) {
    let url = "https://apishopify.grupotenerife.com/api/SAP/" + current_sku;

    let xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function () {
      if (xmlHttp.readyState == 4) {
        $(".inventory_loading").hide();

        if (xmlHttp.status == 200) {
          let data = JSON.parse(xmlHttp.responseText);

          if (data.numPcs != "NA")
            $(".inventory_rows.stock_a").append("<span>&nbsp;&nbsp;" + data.numPcs + " </span>");
          else $(".inventory_rows.stock_a").hide();

          if (data.qtyAvailable != "NA")
            $(".inventory_rows.stock_b").append("<span>&nbsp;&nbsp;" + data.qtyAvailable + " SQF</span>");
          else $(".inventory_rows.stock_b").hide();

          if (data.qtyAVG != "NA")
            $(".inventory_rows.stock_c").append("<span>&nbsp;&nbsp;" + data.qtyAVG + " SQF</span>");
          else $(".inventory_rows.stock_c").hide();
        } else if (xmlHttp.status == 500) {          
          $(".inventory_rows.stock_a").append("<span>&nbsp;&nbsp;0</span>");
          $(".inventory_rows.stock_b").append("<span>&nbsp;&nbsp;0 SQF</span>");
          $(".inventory_rows.stock_c").append("<span>&nbsp;&nbsp;0 SQF</span>");
        } else {          
          $(".inventory_rows.stock_a,.inventory_rows.stock_b,.inventory_rows.stock_c").hide();
        }
      }
    };
    xmlHttp.open("GET", url, true);
    xmlHttp.send(null);
  } else {
    $(".inventory_loading").hide();
    $(".inventory_rows.stock_a,.inventory_rows.stock_b,.inventory_rows.stock_c").hide();
  }
});
